import type { FieldValues } from "react-hook-form"
import { FormTextField, type FormTextFieldProps } from "../FormTextField"

export type FormPhoneFieldProps<TFieldValues extends FieldValues = FieldValues> =
  FormTextFieldProps<TFieldValues>

export const FormPhoneField = <TFieldValues extends FieldValues = FieldValues>(
  props: FormPhoneFieldProps<TFieldValues>,
) => <FormTextField<TFieldValues> type="tel" {...props} />
